import { Link } from 'react-router-dom'
import classes from './TableNameLink.module.css'
import { useSelector } from 'react-redux';
// import { retrieveAllWorkQs } from '../../lib/systemData';
import PatientOrChart from '../patient/page/PatientOrChart';
import { NGvsCaseid } from '../../layout/NGvsCaseid';

export default function TableNameLink({text, case_id, case_data}) {
    // const selectedWorkQueue = useSelector((state) => state.workqueue.selectedWorkQueue);

    return <div className={classes.name_cell}>
            <PatientOrChart item={{case: case_data}} color={'var(--white)'}/>
        {/* <Link to={`/cases/${case_id}`}>
            {text}
        </Link>   */}
        <NGvsCaseid item={case_data} noWorkq={true} caseid={case_id} person_number={case_data?.patient?.person_number}>{text}</NGvsCaseid>
    </div>
}